import React from 'react';
import { FiX, FiTool, FiAlertCircle, FiChevronRight, FiUsers } from 'react-icons/fi';

const LabBatchConfirmationModal = ({
  isOpen,
  onClose,
  classData = {},
  labSubjects = [],
  labSubjectCount = 0,
  onCreateNow,
  onCreateLater,
  isMappingDriven = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden flex flex-col animate-fadeIn">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-5 bg-gradient-to-r from-indigo-700 to-purple-600">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
              <FiTool className="w-6 h-6 text-white" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-white tracking-wide">Lab Batch Required</h2>
              <p className="text-indigo-100 text-xs mt-1">Configure lab batches for <span className="font-semibold">{classData.className}</span></p>
            </div>
          </div>
          <button onClick={onClose} className="text-white hover:text-indigo-200 p-2 rounded-lg transition-colors" aria-label="Close">
            <FiX className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 flex-1 flex flex-col gap-6 overflow-y-auto">
          <div className="flex items-center gap-3 bg-indigo-50 border border-indigo-100 rounded-lg p-4">
            <FiAlertCircle className="w-6 h-6 text-indigo-500 flex-shrink-0" />
            <div>
              <div className="text-sm font-semibold text-indigo-900 mb-1">Lab Subjects Detected</div>
              <div className="text-xs text-indigo-700">{labSubjectCount} lab subject{labSubjectCount !== 1 ? 's' : ''} require batch configuration for this class.</div>
            </div>
          </div>

          {/* Lab Subjects List */}
          {labSubjects.length > 0 && (
            <div className="bg-white border border-slate-200 rounded-lg p-4 flex flex-col gap-2">
              <div className="text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider">Lab Subjects</div>
              <div className="flex flex-wrap gap-2">
                {labSubjects.map((subj, idx) => (
                  <div key={subj._id || idx} className="flex items-center gap-2 px-3 py-1.5 bg-indigo-100 text-indigo-800 rounded-full text-xs font-medium border border-indigo-200">
                    <FiTool className="w-3 h-3" />
                    <span>{subj.name}</span>
                    <span className="text-indigo-500">({subj.subjectCode || subj.code})</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Info Box */}
          <div className="bg-gradient-to-r from-purple-50 to-indigo-50 border border-purple-100 rounded-lg p-4 flex items-center gap-3">
            <FiUsers className="w-6 h-6 text-purple-500 flex-shrink-0" />
            <div className="text-xs text-purple-900">
              <strong>Why batches?</strong> Lab subjects require students to be split into smaller groups for practical sessions. You can set up batches now or continue and configure them later.
            </div>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="bg-slate-50 border-t border-slate-200 px-6 py-4 flex flex-col sm:flex-row gap-3 sm:gap-4 justify-end items-stretch sm:items-center">
          <button
            onClick={onCreateLater}
            className="flex-1 sm:flex-none px-4 py-2 rounded-lg border border-slate-300 bg-white text-slate-700 font-semibold hover:bg-slate-100 transition-colors text-sm shadow-sm"
          >
            Continue Without Batches
          </button>
          <button
            onClick={onCreateNow}
            className="flex-1 sm:flex-none px-4 py-2 rounded-lg bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold hover:from-indigo-700 hover:to-purple-700 transition-colors text-sm shadow-md flex items-center gap-2 justify-center"
            autoFocus
          >
            <FiChevronRight className="w-4 h-4" />
            Set Up Lab Batches
          </button>
        </div>
      </div>
    </div>
  );
};

export default LabBatchConfirmationModal;